import React from 'react';
import './Plasticfliptop.css';
import flipto from '../../../imgs/fliptop.webp';

const Plasticfliptop = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">How are Plastic Flip Top Bottle Caps Made?</h2>
                                <p className="Cavity-date">Oct. 21, 2022</p>

               
                <div className="Ordinary">
                    <img src={flipto} alt="72 Cavity PET Preforms Machine" className="Cavity-image"/>
                </div>
                 <p className="Ordinary-text">Plastic bottle caps are mainly used in beverage industry (mineral water), 
                    edible oil industry, sauce and vinegar condiment industry,
                     chemical industry, lubricating oil industry and paint and coating industry.</p>
                      <p className="Ordinary-text">For packaging or filling enterprises, plastic bottle caps should be safe,
                         beautiful, reasonably priced,
                         free of quality defects, and well-matched with plastic bottles for sealing;</p>
                           <p className="Ordinary-text">For the final consumer, 
                            the plastic bottle caps should be a package that is easy to open,
                             light in weight, safe, and will not cause harm to people.</p>

            </div>

        </div>
    );
};

export default Plasticfliptop;
